const Reports = () => import(/* webpackChunkName: "reports" */ '@/pages/reports');
const ReportsSetup = () => import(/* webpackChunkName: "reports" */ '@/pages/reports/setup');
const ReportsRecap = () => import(/* webpackChunkName: "reports" */ '@/pages/reports/recap');

export default [
  {
    path: 'reports',
    name: 'Reports',
    component: Reports,
  },
  {
    path: 'reports/setup/:report_id?',
    name: 'Reports / Setup',
    component: ReportsSetup,
  },
  {
    path: 'reports/recap/:report_id/:period_start',
    name: 'Reports / Recap',
    component: ReportsRecap,
  },
];
